exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table thead:first-child th, table.dataTable tbody>tr>td, table.dataTable tfoot>tr>th{\n    background-color: #EEEEEE\n}\n.sugget-container{\n    max-height: 230px;\n    max-width: 454px;\n    min-width: 150px;\n    z-index: 999;\n    margin-top: 5px;\n    background: #fff;\n    box-shadow: 0px 2px 11px #afabab;\n    overflow-y: auto\n}\n.sugget-container > ul > li:hover{\n    cursor: pointer;\n    background: #fafafa\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/evs/business/modal-manager/distribution-manager/distribution-manager.component.css
// module id = ../../../../../src/app/pages/admin/evs/business/modal-manager/distribution-manager/distribution-manager.component.css
// module chunks = 3